exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".service-provider {\n  max-height: 230px;\n  padding: 5px;\n  position: absolute;\n  width: 350px;\n  border: 1px solid #b2b2b2;\n  background: #ffff;\n  top: 0;\n  z-index: 1; }\n\n.list-service-provider {\n  max-height: 200px;\n  /*  z-index: 10;*/ }\n  .list-service-provider ul li {\n    list-style-type: none;\n    border-bottom: 1px dashed rgba(178, 178, 178, 0.55); }\n    .list-service-provider ul li .title-servicep {\n      font-size: 1rem;\n      cursor: pointer; }\n    .list-service-provider ul li .title-servicep:hover {\n      background: #9bc2e6; }\n    .list-service-provider ul li .address-servicep {\n      font-size: 0.9rem;\n      color: #0a6aa1;\n      cursor: pointer; }\n\n.list-sp-disabled {\n  background-color: transparent !important; }\n\n.content-list {\n  margin: 0;\n  padding: 0;\n  position: relative; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/service-provider/components/autocomplete-service-provider/autocomplete-service-provider.component.scss
// module id = 2103
// module chunks = 66